var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFacebookLogo = function SvgFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16h-3.6v13h-5.4V16H10v-4.6h2.6v-3c0-2.1 1-5.4 5.4-5.4h4v4.5h-2.9c-.5 0-1.1.2-1.1 1.3v2.7h4l-.5 4.5z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  })));
};
export default SvgFacebookLogo;